import { Button, Grid, Typography } from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import React, { useState } from "react";
import { CreateWorker } from "../CreateWorker/ModalCreateWorker";
import { DeleteWorker } from "../DeleteWorker/ModalDeleteWorker";
import { EditWorker } from "../EditWorker/ModalEditWorker";
import { useTableData } from "./customHooks/useTableData";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiDataGrid-row": {
				cursor: "pointer",
			},
			"& .MuiDataGrid-columnHeaderTitle, & .MuiTablePagination-caption": {
				fontWeight: "bold",
				fontSize: "12px",
			},
			"& .MuiDataGrid-columnHeaderTitleContainer": {
				padding: "0",
			},
			// '& .MuiButtonBase-root':{
			//   padding: "8px 0",
			// },
			"& .MuiDataGrid-cell--textLeft": {
				fontSize: "12px",
			},
		},
		relative: {
			position: "relative",
		},
		textfield: {
			margin: theme.spacing(2),
		},
		btnModal: {
			display: "flex",
			justifyContent: "flex-end",
		},
		dataTable: {
			padding: theme.spacing(1, 2),
		},
	}),
);
type Props = {
	isLoading: boolean;
	getWorkersFromAPI: Function;
};

export const TableWorkers = ({ isLoading, getWorkersFromAPI }: Props) => {
	const [modalCreateActive, setModalCreateActive] = useState(false);
	const [modalEditDataWorker, setModalEditDataWorker] = useState(false);
	const [modalDeleteWorker, setModalDeleteWorker] = useState(false);

	const [workerIdForEdit, setWorkerIdForEdit] = useState<number | null>(null);
	const [workerIdForDelete, setWorkerIdForDelete] = useState<number | null>(
		null,
	);

	const classes = useStyles();

	const { rows, columns } = useTableData({
		setWorkerIdForEdit,
		setModalEditDataWorker,
		setWorkerIdForDelete,
		setModalDeleteWorker,
	});

	return (
		<Grid container justifyContent="center">
			<Grid item md={12} xs={12} style={{ padding: "0 15px" }}>
				<Typography
					variant="h5"
					style={{ margin: "20px 0 20px", fontWeight: 600 }}
				>
					Workers Management
				</Typography>
			</Grid>
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				className={classes.root}
			>
				<Grid
					item
					md={12}
					xs={12}
					style={{ padding: "0 15px" }}
					className={classes.relative}
				>
					<EditWorker
						show={modalEditDataWorker}
						workerIdForEdit={workerIdForEdit}
						onHide={(shouldUpdate: boolean) => {
							setModalEditDataWorker(false);
							setWorkerIdForEdit(null);
							if (shouldUpdate) getWorkersFromAPI().then(() => {});
						}}
					/>
					<CreateWorker
						show={modalCreateActive}
						onHide={(shouldUpdate: boolean) => {
							setModalCreateActive(false);
							if (shouldUpdate) getWorkersFromAPI().then(() => {});
						}}
					/>{" "}
					<DeleteWorker
						show={modalDeleteWorker}
						workerIdForDelete={workerIdForDelete}
						onHide={(shouldUpdate: boolean) => {
							setModalDeleteWorker(false);
							if (shouldUpdate) getWorkersFromAPI().then(() => {});
						}}
					/>

					<div style={{ width: "100%", height: "60vh" }}>
						<DataGrid
							className={classes.dataTable}
							density={"compact"}
							loading={isLoading}
							rows={rows}
							columns={columns}
							pageSize={25}
							disableColumnMenu
							disableColumnFilter
							disableColumnSelector
							disableSelectionOnClick
						/>
					</div>
					<Grid container justifyContent="flex-end">
						<Grid item md={2} xs={12} className={classes.btnModal}>
							<Button
								variant="contained"
								color="primary"
								onClick={() => setModalCreateActive(!modalCreateActive)}
								fullWidth
								style={{ margin: "20px 0 20px" }}
							>
								New worker
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
